import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "./style.css";
import { API_BASE_URL } from "../../../config/config";

const TendersComp = () => {
  const [tenders, setTenders] = useState([]);
  const [competitions, setCompetitions] = useState([]);
  // status: "loading" | "loaded" | "empty" | "error"
  const [tenderStatus, setTenderStatus] = useState("loading");
  const [competitionStatus, setCompetitionStatus] = useState("loading");
  const { t, i18n } = useTranslation();

  const languageMap = {
    tj: 1,
    ru: 2,
    en: 3,
  };

  const getLanguageCode = (lang) => languageMap[lang] || 2;

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    setTenderStatus("loading");

    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=4`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => {
        const filteredTenders = response.data.enttities
          ?.filter((item) => item.type === 4)
          .slice(0, 4);

        if (!filteredTenders?.length) {
          setTenders([]);
          setTenderStatus("empty");
        } else {
          setTenders(filteredTenders);
          setTenderStatus("loaded");
        }
      })
      .catch((error) => {
        console.error("Error fetching tenders:", error);
        setTenderStatus("error");
      });
  }, [i18n.language]);

  useEffect(() => {
    const langCode = getLanguageCode(i18n.language);
    setCompetitionStatus("loading");

    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=3`, {
        headers: { accept: "text/plain", "api-version": "1.0" },
      })
      .then((response) => {
        const filteredCompetitions = response.data.enttities
          ?.filter((item) => item.type === 3)
          .slice(0, 4);

        if (!filteredCompetitions?.length) {
          setCompetitions([]);
          setCompetitionStatus("empty");
        } else {
          setCompetitions(filteredCompetitions);
          setCompetitionStatus("loaded");
        }
      })
      .catch((error) => {
        console.error("Error fetching competitions:", error);
        setCompetitionStatus("error");
      });
  }, [i18n.language]);

  const RenderCard = ({ item, linkPrefix }) => (
    <div className="col-md-3 mb-4">
      <div className="card h-100 d-flex flex-column shadow-sm border-0">
        {item.image && (
          <img
            src={item.image}
            alt="not found"
            className="card-img-top"
            style={{
              height: "200px",
              objectFit: "cover",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
            }}
          />
        )}
        <div className="card-body d-flex flex-column p-3">
          <h5 className="card-title fw-bold mb-2 text-dark">
            {item.title?.length > 60
              ? item.title.slice(0, 60) + "..."
              : item.title}
          </h5>
          <p className="card-text text-muted mb-4" style={{ flexGrow: 1 }}>
            {item.shortDesc?.length > 100
              ? item.shortDesc.slice(0, 100) + "..."
              : item.shortDesc}
          </p>
          <div className="mt-auto">
            <Link
              to={`/${linkPrefix}/show/${item.id}`}
              className="btn ButtonM w-100"
            >
              {t("More details")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  const renderSectionBody = (status, items, linkPrefix, emptyKey) => {
    if (status === "loading") {
      return (
        <div className="col-12 text-center py-4">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      );
    }

    if (status === "error") {
      return (
        <div className="col-12 text-center text-danger">
          <p>{t("NoAvailable")}</p>
        </div>
      );
    }

    if (status === "empty") {
      return (
        <div className="col-12 text-center empty-state-text">
          <p>{t(emptyKey)}</p>
        </div>
      );
    }

    return items.map((item, index) => (
      <RenderCard key={index} item={item} linkPrefix={linkPrefix} />
    ));
  };

  return (
    <div>
      <div className="container tenderUp mt-5">
        <h2 className="mb-5 titleOne">{t("Tenders")}</h2>
        <div className="row">
          {renderSectionBody(
            tenderStatus,
            tenders,
            "tenders",
            "NoTendersAvailable",
          )}
        </div>
      </div>
      <div className="container mt-5">
        <h2 className="mb-5 titleOne">{t("Competitions")}</h2>
        <div className="row">
          {renderSectionBody(
            competitionStatus,
            competitions,
            "competitions",
            "NoCompetitionsAvailable",
          )}
        </div>
      </div>
    </div>
  );
};

export default TendersComp;
